<template lang="pug">
  modal(
    :title='$t("krea.resource.sidebar.deleteClassModal.title", { classNumber: modalProps.classNumber })'
    @closeModal='closeModal'
  )
    .column.m-top-2
      p.text-normal {{ $t('krea.resource.sidebar.deleteClassModal.message') }}
      .row.middle.m-top-2
        k-switch(:value='allClass' @change='toggleAllClass')
        span.text-normal.m-left-1 {{ $t('krea.resource.sidebar.deleteClassModal.allClass') }}
      .warning.m-top-2(v-if='allClass')
        span.text-normal.red {{ $t('krea.resource.sidebar.deleteClassModal.warning') }}
      .column.m-top-2
        label.text-normal(v-html='confirmLabel')
        text-input(
          name="confirm"
          italicPlaceholder
          :validations='$v.confirm'
          :value='confirm'
          :updateMethod='updateConfirm'
          :placeholder='confirmExpected'
          :errorMessage='$t("krea.resource.sidebar.deleteClassModal.confirmError")'
        )
      .row.center.m-top-3
        button.main-button.white.continue.m4-right-5(@click='closeModal' type='button')
          | {{ $t('choiceModal.cancel') }}
        button.main-button.no-border(@click='deleteClass' type='button')
          | {{ $t('krea.resource.sidebar.deleteClassModal.rightLabel') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { i18n } from '../../main'
import { routes } from '../../router'
import KSwitch from '../Inputs/KSwitch'
import TextInput from '../Inputs/TextInput'
import { required, sameAs } from 'vuelidate/lib/validators'
import Modal from '../Modal'

export default {
  components: { Modal, KSwitch, TextInput },
  data() {
    return {
      allClass: false,
      confirm: ''
    }
  },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.deleteKreaClassModal.props,
      activeLanguage: state => state.kreaResource.activeLanguage
    }),
    confirmLabel() {
      if (this.allClass) return i18n.t('krea.resource.sidebar.deleteClassModal.typeConfirmAll')
      else {
        return (this.$route.name === routes.kreaResourceStudentClass)
          ? i18n.t('krea.resource.sidebar.deleteClassModal.typeConfirmStudent')
          : i18n.t('krea.resource.sidebar.deleteClassModal.typeConfirmTeacher')
      }
    },
    confirmExpected() {
      if (this.allClass) return i18n.t('krea.resource.sidebar.deleteClassModal.allPlaceholder')
      else {
        return (this.$route.name === routes.kreaResourceStudentClass)
          ? i18n.t('krea.resource.sidebar.deleteClassModal.studentPlaceholder')
          : i18n.t('krea.resource.sidebar.deleteClassModal.teacherPlaceholder')
      }
    }
  },
  methods: {
    ...mapActions([
      'hideElement',
      'removeKreaResourceClass',
      'clearKreaStudentClass',
      'clearKreaTeacherClass'
    ]),
    toggleAllClass(name, value) {
      this.allClass = value
      this.confirm = ''
    },
    updateConfirm(value) {
      this.confirm = value
    },
    deleteClass() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      const { classNumber } = this.modalProps
      if (this.allClass) {
        this.removeKreaResourceClass({ locale: this.activeLanguage, classNumber })
        if (this.$route.name === routes.kreaResourceStudentClass) this.$router.push({ name: routes.kreaResourceStudentTrigger })
        else this.$router.push({ name: routes.kreaResourceTeacherTrigger })
      } else {
        if (this.$route.name === routes.kreaResourceStudentClass) this.clearKreaStudentClass({ locale: this.activeLanguage, classNumber })
        else this.clearKreaTeacherClass({ locale: this.activeLanguage, classNumber })
      }
      this.closeModal()
    },
    closeModal() {
      this.hideElement({ element: 'deleteKreaClassModal' })
    }
  },
  validations() {
    return {
      confirm: { required, sameAsConfirm: sameAs(() => this.confirmExpected) }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.warning{
  border-radius: 5px;
  background-color: #ff566f20;
  padding: 15px;
}
</style>
